<script>
import JSZip from 'jszip'
import parser from 'fast-xml-parser'
import FieldUpload from '@/components/FieldUpload'
export default {
  name: 'document-item',
  components: {
    FieldUpload
  },
  data () {
    return {
      dialog: false,
      typeVouchers: [
        { id: 1, value: 'FACTURA ELECTRÓNICA' },
        { id: 3, value: 'BOLETA ELECTRÓNICA' },
        { id: 7, value: 'NOTA DE CRÉDITO' },
        { id: 8, value: 'NOTA DE DÉBITO' }
      ],
      fileNameXML: 'Seleccione documento XML',
      fileNamePDF: 'Seleccione documento PDF',
      document: {
        tipo: null,
        serie: '',
        numero: '',
        fecha: null,
        total: 0
      }
    }
  },
  methods: {
    onChangeFileXML (evt) {
      let file = evt.target.files[0]
      this.fileNameXML = file.name
      JSZip.loadAsync(file).then((zip) => {
        zip.forEach((relativePath, entry) => {
          entry.async('string').then((content) => {
            let data = parser.parse(content)
            this.document.serie = data.Invoice['cbc:ID'].substring(0, 4)
            this.document.numero = data.Invoice['cbc:ID'].substring(5)
            this.document.tipo = data.Invoice['cbc:InvoiceTypeCode']
            this.document.fecha = data.Invoice['cbc:IssueDate']
            this.document.total =
              data.Invoice['cac:LegalMonetaryTotal']['cbc:PayableAmount']
          })
        })
      })
    },
    onChangeFilePDF (evt) {
      let file = evt.target.files[0]
      this.fileNamePDF = file.name
    }
  },
  computed: {
    dateFormat () {
      if (this.document.fecha == null) return null
      const [year, month, day] = this.document.fecha.split('-')

      return `${day}-${month}-${year}`
    }
  }

}
</script>
<template lang="pug">
v-dialog(
  v-model="dialog"
  max-width="500px"
)
  v-btn(
    color="primary"
    slot="activator"
    ) Nuevo
  v-card
    v-card-title
      span(class="headline") Nuevo Documento
    v-card-text
      field-upload(
        @change-file="onChangeFileXML"
        accept=".zip"
      ) {{fileNameXML}}
      field-upload(
        @change-file="onChangeFilePDF"
        accept=".pdf"
      ) {{fileNamePDF}}
      v-form
        v-container(grid-list-sm)
          v-layout(
            row
            wrap
            )
            v-flex(sm12)
              v-select(
                label="Tipo de documento"
                :items="typeVouchers"
                item-text="value"
                item-value="id"
                v-model="document.tipo"
                readonly
              )
            v-flex(sm4)
              v-text-field(
                label="Serie"
                v-model="document.serie"
                readonly
              )
            v-spacer
            v-flex(sm6)
              v-text-field(
                label="Número correlativo"
                v-model="document.numero"
                readonly
              )
            v-flex(sm5)
                v-text-field(
                  v-model="dateFormat"
                  label="Fecha de emisión"
                  readonly
                  )
            v-spacer
            v-flex(sm5)
              v-text-field(
                v-model="document.total"
                label="Monto total"
                readonly
                )
    v-card-actions
      v-btn(color="primary")
        v-icon save
        |Grabar
</template>
